import * as req from 'api/actions';
import moment from 'moment';
import * as c from './constant';

export const getTotalStats = (payload, callback) =>
  req.item(
    c.GET_TOTAL_STATS,
    'api/v1/administrators/occupational_permit_dashboard/statistics',
    payload,
    callback
  );

export const getGraphStats = (
  payload = {
    period: 'MONTHLY',
    date_from: moment()
      .startOf('year')
      .format('YYYY-MM-DD'),
    date_to: moment()
      .endOf('year')
      .format('YYYY-MM-DD'),
    permit_type: 'Occupational Permit',
  },
  callback
) =>
  req.list(
    c.GET_GRAPH_STATS,
    'api/v1/administrators/dashboard/graph',
    payload,
    callback
  );
